export default "__VITE_ASSET__Dm61hBfu__ 400w, __VITE_ASSET__Ati$x6oH__ 800w, __VITE_ASSET__2A0VEUfo__ 1024w";